import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import type { VisibilityChipProps } from '../types';

/**
 * VisibilityChip - Display visibility status as colored chip
 *
 * Pure presentational component that shows document visibility level
 * with appropriate colors:
 * - Public: success (green)
 * - Organization: secondary (purple)
 * - Private: default (gray)
 *
 * @param visibility - The visibility level ('public', 'organization', 'private')
 */
export const VisibilityChip: React.FC<VisibilityChipProps> = ({ visibility }) => {
  const { t } = useTranslation();

  const label = visibility === 'public'
    ? t('documents.visibility.public')
    : visibility === 'organization'
    ? t('documents.visibility.organization')
    : visibility === 'private'
    ? t('documents.visibility.private')
    : visibility;

  const color = visibility === 'organization'
    ? 'secondary'
    : visibility === 'public'
    ? 'success'
    : 'default';

  return (
    <Chip
      label={label}
      color={color}
      size="small"
    />
  );
};

VisibilityChip.displayName = 'VisibilityChip';
